var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBooks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.022C10.875 3.944 12 6.1 12 6.1s1.125-2.156 9-1.078V17.96c-6.75-1.078-9 .539-9 .539s-2.25-1.617-9-.54V5.023zM12 20V5",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0zIDUuMDIxOTRDMTAuODc1IDMuOTQzNjkgMTIgNi4xMDAxOSAxMiA2LjEwMDE5QzEyIDYuMTAwMTkgMTMuMTI1IDMuOTQzNjkgMjEgNS4wMjE5NEMyMSA1LjAyMTk0IDIxIDE2Ljg4MjcgMjEgMTcuOTYwOUMxNC4yNSAxNi44ODI3IDEyIDE4LjUgMTIgMTguNUMxMiAxOC41IDkuNzUgMTYuODgyNyAzIDE3Ljk2MDlDMyAxNi44ODI3IDMgNS4wMjE5NCAzIDUuMDIxOTRaIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxsaW5lIHgxPSIxMiIgeTE9IjIwLjAwMDEiIHgyPSIxMiIgeTI9IjUuMDAwMDYiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjIiLz4KPC9zdmc+Cg==";
export { SvgBooks as ReactComponent };